export default __webpack_public_path__ + "static/weather--storm-6aea59b89984d28fecf99db0d58d9f02.png";